// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  campaignId: __t.string().name("campaign_id"),
  name: __t.string(),
  founderId: __t.string().name("founder_id"),
  owner: __t.option(__t.string()),
  lon: __t.f64(),
  lat: __t.f64(),
  foundedTick: __t.u64().name("founded_tick"),
  population: __t.u32(),
});
